'use client';

import styled from '@emotion/styled';
import { ContentWrap, Css, H3, Responsive } from '../../../../ui';

export const Section = styled(ContentWrap.withComponent('section'))<{
	removeTopPadding?: boolean;
}>`
	padding: ${Css.pxToRem(32)} 0;
	${({ removeTopPadding }) => removeTopPadding && `padding-top: 0;`}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		h3 {
			font-size: ${Css.pxToRem(32)};
		}
	}
`;

export const SectionHeader = styled(H3)`
	margin-bottom: ${Css.pxToRem(16)};
	max-width: 50%;
	line-height: normal;
`;
